export class businessOwner
{
  
    isOwner= true
    type= "company"
    name= ""
    id= ""
    ownership= 0.00
    loan= 0.00
    insuredName= ""
    insuredId= ""
    tax= true
    taxAmount= 20
    deathExisting= 0.00
    disabilityExisting= 0.00
    deathNeeded = 0.00
    disabilityNeeded = 0.00
    minusInheritance= 0.00
    saleOnDeath = []
   
}

export class Purchaser 
{
   ownerRef = null
   purchaseFrom = null
   standardPurchase = 0.00
   customPurchase = 0.00
   policyNeeded = true

}

export class Heir 
{
   name = ""
   id = ""
   to = ""
   inherit = 0.00
   perantOwnership = 0.00
}

export class KeyPerson 
{
   name = ""
   id = ""
}

export class Surety 
{
   name = ""
   id = ""
}


// WEBPACK FOOTER //
// ./src/views/Bna/steps/objects/bnaClasses.jsx